"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var contract_wrappers_1 = require("@polymathnetwork/contract-wrappers");

var Procedure_1 = require("./Procedure");

var ApproveErc20_1 = require("./ApproveErc20");

var types_1 = require("../types");

var PolymathError_1 = require("../PolymathError");

var entities_1 = require("../entities");

var utils_1 = require("../utils");

var bigNumberToDate = contract_wrappers_1.conversionUtils.bigNumberToDate;
/**
 * Procedure that reserves a token ticker (symbol) to be used later on to launch a Security Token
 *
 * ***Note if the Reservation expires and the corresponding Security Token hasn't been launched yet, another issuer can reserve the same ticker***
 */

var ReserveSecurityToken =
/*#__PURE__*/
function (_Procedure_1$Procedur) {
  _inherits(ReserveSecurityToken, _Procedure_1$Procedur);

  function ReserveSecurityToken() {
    var _this;

    _classCallCheck(this, ReserveSecurityToken);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReserveSecurityToken).apply(this, arguments));
    _this.type = types_1.ProcedureType.ReserveSecurityToken;
    return _this;
  }
  /**
   * Reserve a new ticker
   *
   * Note that this procedure will fail if ticker has already been registered
   */


  _createClass(ReserveSecurityToken, [{
    key: "prepareTransactions",
    value: function prepareTransactions() {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var args, context, addProcedure, addTransaction, symbol, owner, securityTokenRegistry, currentWallet, securityTokenReservationFactory, ownerAddress, isAvailable, _ref, _ref2, usdFee, polyFee, _ref3, _ref4, reservation;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                args = this.args, context = this.context, addProcedure = this.addProcedure, addTransaction = this.addTransaction;
                symbol = args.symbol, owner = args.owner;
                securityTokenRegistry = context.contractWrappers.securityTokenRegistry, currentWallet = context.currentWallet, securityTokenReservationFactory = context.factories.securityTokenReservationFactory;

                if (!owner) {
                  _context2.next = 7;
                  break;
                }

                ownerAddress = owner;
                _context2.next = 10;
                break;

              case 7:
                _context2.next = 9;
                return currentWallet.address();

              case 9:
                ownerAddress = _context2.sent;

              case 10:
                _context2.next = 12;
                return securityTokenRegistry.tickerAvailable({
                  ticker: symbol
                });

              case 12:
                isAvailable = _context2.sent;

                if (isAvailable) {
                  _context2.next = 15;
                  break;
                }

                throw new PolymathError_1.PolymathError({
                  message: "Ticker ".concat(symbol, " has already been registered"),
                  code: types_1.ErrorCode.ProcedureValidationError
                });

              case 15:
                _context2.next = 17;
                return securityTokenRegistry.getFees({
                  feeType: contract_wrappers_1.FeeType.TickerRegFee
                });

              case 17:
                _ref = _context2.sent;
                _ref2 = _slicedToArray(_ref, 2);
                usdFee = _ref2[0];
                polyFee = _ref2[1];
                _context2.t0 = addProcedure(ApproveErc20_1.ApproveErc20);
                _context2.t1 = polyFee;
                _context2.next = 25;
                return securityTokenRegistry.address();

              case 25:
                _context2.t2 = _context2.sent;
                _context2.t3 = {
                  amount: _context2.t1,
                  spender: _context2.t2
                };
                _context2.next = 29;
                return (0, _context2.t0)(_context2.t3);

              case 29:
                _context2.next = 31;
                return addTransaction(securityTokenRegistry.registerNewTicker, {
                  tag: types_1.PolyTransactionTag.ReserveSecurityToken,
                  fees: {
                    poly: polyFee,
                    usd: usdFee
                  },
                  resolvers: [function (receipt) {
                    return __awaiter(_this2, void 0, void 0,
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee() {
                      var logs, _utils_1$findEvents, _utils_1$findEvents2, event, eventArgs, _ticker, _expiryDate, _owner, _registrationDate;

                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              logs = receipt.logs;
                              _utils_1$findEvents = utils_1.findEvents({
                                logs: logs,
                                eventName: contract_wrappers_1.SecurityTokenRegistryEvents.RegisterTicker
                              }), _utils_1$findEvents2 = _slicedToArray(_utils_1$findEvents, 1), event = _utils_1$findEvents2[0];

                              if (!event) {
                                _context.next = 6;
                                break;
                              }

                              eventArgs = event.args;
                              _ticker = eventArgs._ticker, _expiryDate = eventArgs._expiryDate, _owner = eventArgs._owner, _registrationDate = eventArgs._registrationDate;
                              return _context.abrupt("return", securityTokenReservationFactory.create(entities_1.SecurityTokenReservation.generateId({
                                symbol: _ticker
                              }), {
                                expiry: bigNumberToDate(_expiryDate),
                                reservedAt: bigNumberToDate(_registrationDate),
                                ownerAddress: _owner
                              }));

                            case 6:
                              throw new PolymathError_1.PolymathError({
                                code: types_1.ErrorCode.UnexpectedEventLogs,
                                message: "The Security Token was successfully reserved but the corresponding event wasn't fired. Please report this issue to the Polymath team."
                              });

                            case 7:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                  }]
                })({
                  owner: ownerAddress,
                  ticker: symbol
                });

              case 31:
                _ref3 = _context2.sent;
                _ref4 = _slicedToArray(_ref3, 1);
                reservation = _ref4[0];
                return _context2.abrupt("return", reservation);

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }]);

  return ReserveSecurityToken;
}(Procedure_1.Procedure);

exports.ReserveSecurityToken = ReserveSecurityToken;